import { Reducer } from 'redux';
import { Actions } from '../constants/deviceCustomizationConstants';
import DeviceCustomizationState from '../state/DeviceCustomizationState';
import _get from 'lodash/get';

const deviceCustomizationReducer: Reducer<DeviceCustomizationState> =
  (state: DeviceCustomizationState = new DeviceCustomizationState(), action) => {
    switch (action.type) {
      case Actions.SET_DEVICE_CUSTOMIZATION_URL:
        return state.set('url', _get(action.payload, 'url'));
      default:
        return state;
    }
  };

export default deviceCustomizationReducer;
